import { useSelector } from "react-redux"
import styled from "styled-components"
import InputText from "../../../shared/input/new/InputText"
import { useState } from "react"
import Btn from "../../../shared/button/Btn"
import { useDispatch } from "react-redux"
import MessageFileInput from "../../../shared/input/special/MessageFileInput"
import { createBlogFAQ } from "../../../../features/admin3/admin3Slice"
import { Editor } from "@tinymce/tinymce-react"
import { FaRegTrashAlt } from "react-icons/fa"


const Container = styled.div`
    height: 100%;
    width: 100%;
    
    .blog-container{
        height: calc(100% - 120px);
        width: 100%;
        max-height: 4000px !important;
        overflow: auto;
        padding: 25px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .col{
            display: flex;
            flex-direction: column;
            gap: 5px;
            .error{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: var(--color-main) !important;
            }
        }
        .img-container{
            display: flex;
            align-items: center;
            gap: 20px;
            .delete{
                cursor: pointer;
                background-color: var(--color-main);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
                svg{
                    color: #fff;
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    .tox-statusbar__branding {
        display: none !important;
    }
`

const UpdateBlogNewFAQSide = () => {
    const dispatch = useDispatch()
    const {selectedBlog} = useSelector(state => state.admin3)
    const [listAndDetailImage, setListAndDetailImage] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const [listData, setListData] = useState({
        question: "",
        answer: "",
        faqImageAlt: ""
    })

    const handleChange = (e) => {
        setListData({...listData, [e.target.name]: e.target.value})
    }

    const handleEditorChange = (answer) => {
        setListData({ ...listData, answer }); // Editor içeriğini güncelle
    };

    const handleCreateBlogList = () => {
        setIsSubmitting(true)

        if (listAndDetailImage && !listData.faqImageAlt) {
            return;
        }

        if(listData.question && listData.answer){
            const formData = new FormData()
            formData.append("question", listData.question)
            formData.append("answer", listData.answer)
            formData.append("faqImageAlt", listData.faqImageAlt || "")
            formData.append("faqImage", listAndDetailImage)
            formData.append("blogId", selectedBlog.id)
            
            dispatch(createBlogFAQ(formData))
            setListData({
                question: "",
                answer: "",
                faqImageAlt: ""
    
            })
            setListAndDetailImage(null)
        }
        
    }

  return (

    <Container>

        <div className="blog-container">
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.question} setData={(e) => handleChange(e)} name={"question"} labelText={"Soru"} />
                {isSubmitting && !listData.question &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>
            <div className="col">
                <Editor
                    apiKey="4b0bsl6u6sv8iqg9bh7giddxo16ulrl9whc4cmz46j7dsirn" // API anahtarınızı buraya koyun
                    value={listData.answer}
                    init={{
                        height: 500,
                        menubar: "format",
                        menu: {
                            format: { title: "Format", items: "bold underline blocks | removeformat" },
                        },
                        plugins: [ 
                            "link", "lists",
                            "advlist", "autolink", "charmap", "print", "preview", "anchor",
                            "searchreplace", "fullscreen",
                            "insertdatetime", "paste", "help", "wordcount", 
                        ],
                        toolbar:
                            "undo redo | formatselect | bold | \
                            bullist numlist outdent indent | link removeformat | help",
                    }}
                    onEditorChange={handleEditorChange}
                />
                {isSubmitting && !listData.answer &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>
            
            <div className="img-container">
                <MessageFileInput setSelectedFile={setListAndDetailImage} />
                <div className="delete" onClick={() => listAndDetailImage(null)}>
                    <FaRegTrashAlt />
                </div>
                
                <InputText inputWidth={"100%"} data={listAndDetailImage?.name} disabled={true} setData={(e) => handleChange(e)} name={"listAndDetailImage"} labelText={"Bloglar Listesi Görseli ve Detay Sayfası Ana Görsel"} />
            </div>
            <div className="col">
                <InputText inputWidth={"100%"} data={listData?.faqImageAlt} setData={(e) => handleChange(e)} name={"faqImageAlt"} labelText={"Alt Etiketi"} />
                {isSubmitting && !listData.faqImageAlt && listAndDetailImage &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>

            <div className="btn-container">
                <Btn width={"200px"} color="#E85446" bgColor="transparent" padding="0 10px" handleClick={handleCreateBlogList} >Ekle</Btn>
            </div>
        </div>
         
    </Container>
  )
}

export default UpdateBlogNewFAQSide